<template>
  <main-content>
    <CreateForm :action="createTicket"></CreateForm>
  </main-content>
</template>

<script>
import MainContent from "@/components/main-content";
import $ from "jquery";
import {KTApp} from "@/plugins/core/app";
import {ticketService} from "@/common/api.service";
import {KTUtil} from "@/plugins/core/util";
import CreateForm from "@/pages/ticket/components/CreateForm";
import toastr from "toastr";


export default {
  name: "create",
  components: {CreateForm, MainContent},
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$store.dispatch('user/fetchForSelect')
    })
  },
  computed: {
    toastr() {
      toastr.options = {
        closeButton: true,
        positionClass: "toast-bottom-center",
        preventDuplicates: false,
        rtl: false
      }
      return toastr
    },
  },
  methods: {
    createTicket(e, query) {
      let form = $(e.target)
      let btn = $('#submit_button')

      form.validate({
        ignore: ":hidden",

        rules: {
          subject: {
            required: true,
          },
          category_id: {
            required: true,
          },
          content: {
            required: true,
          },
          priority: {
            required: true,
          },
        },
      });


      if (!form.valid()) {
        return
      }

      KTApp.progress(btn)
      ticketService.create(query)
          .then(response => {
            this.$router.push('/tickets')
            this.showMsg(form, 'success', response.data.message)
            this.$store.dispatch('badgeCounter/countData')
          })
          .catch(({response}) => {
            console.log(response.data.data);
            if (response.data.data) {
               Object.values(response.data.data).forEach(item => {
                 this.showMsg(form,'danger' ,item)
               })
               return;
            }
            if(response.data.data.created_for.length > 0) {
              this.showMsg(form,'danger' ,response.data.data.created_for[0])
              return;
            }
            this.showMsg(form,'danger' ,response.data.message)
          })
          .finally(() => {
            KTUtil.scrollTop()
            KTApp.unprogress(btn)
          })

    }
  }

}
</script>

<style scoped>

</style>